var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5.5,
    width: 12,
    height: 8,
    fill: "#D9D9D9",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 17,
    height: 4,
    fill: "#9f5448"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 2,
    height: 3,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 2,
    height: 3,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 7,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 11,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 11,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 11,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 11,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 9,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 9,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 7,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 7,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 1,
    height: 1,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 7,
    width: 1,
    height: 1,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.a9b2b9d4426e50d5e4a57188d104cba3.svg";
export { ForwardRef as ReactComponent };